export type NotificationActionTarget =
  | { type: "internal"; url: string }
  | { type: "external"; url: string };

const LEGACY_CONSOLE_PREFIX = /^\/console(?=\/|$)/;

export function resolveNotificationActionUrl(
  value: string,
  currentOrigin?: string,
): NotificationActionTarget | null {
  const url = value.trim();
  if (!url) return null;

  if (/^https:\/\//i.test(url)) {
    try {
      const parsed = new URL(url);
      if (parsed.protocol !== "https:") return null;
      if (currentOrigin && parsed.origin === currentOrigin) {
        return {
          type: "internal",
          url: `${parsed.pathname}${parsed.search}${parsed.hash}`,
        };
      }
      return { type: "external", url };
    } catch {
      return null;
    }
  }

  if (!url.startsWith("/") || url.startsWith("//")) return null;

  return {
    type: "internal",
    url: url.replace(LEGACY_CONSOLE_PREFIX, "/app"),
  };
}
